import { render } from "./HelpVideo.vue?vue&type=template&id=6a1a5fd3&scoped=true"
import script from "./HelpVideo.vue?vue&type=script&lang=js"
export * from "./HelpVideo.vue?vue&type=script&lang=js"

import "./HelpVideo.vue?vue&type=style&index=0&id=6a1a5fd3&scoped=true&lang=css"

import exportComponent from "E:\\CODE\\jb-oa\\jb-oa-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1a5fd3"]])

export default __exports__